import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import {
  WithDoc,
  WithDocLoadAware,
} from "@poseidon/firebase/components/WithDoc";
import Avatar from "@poseidon/ui/components/Avatar";
import { getUserLabel } from "../Users/util";
import { niceDate } from "@poseidon/utils/date";
import { Box } from "@mui/material";

const AdminAvatar = ({ user, ...avatarProps }) => (
  <WithDocLoadAware
    docRef={`admins/${user.id}`}
    Component={({ data: admin, ...props }) => (
      <Avatar
        firstName={admin?.firstName}
        lastName={admin?.lastName}
        {...props}
        {...avatarProps}
      />
    )}
  />
);
const AdminName = ({ user }) => (
  <WithDoc
    docRef={`admins/${user.id}`}
    Component={({ data: admin }) => getUserLabel(admin)}
  />
);

const NoteHeader = ({ user, date }) => {
  const dateTimeFormatted = date ? niceDate(date) : null;
  return (
    <CardHeader
      sx={{ bgColor: "background.default", p: 2 }}
      avatar={<AdminAvatar user={user} size="small" />}
      title={AdminName({ user })}
      subheader={dateTimeFormatted}
      titleTypographyProps={{ variant: "body2" }}
      subheaderTypographyProps={{ variant: "caption" }}
    />
  );
};

export default function NoteLogCard({ title, body, postedBy, createdAt }) {
  return (
    <Card variant="outlined">
      <NoteHeader user={postedBy} date={createdAt} />
      <Box sx={{ pb: 2, px: 2, ml: "48px" }}>
        {title && (
          <Typography variant="subtitle1" color="text.secondary">
            {title}
          </Typography>
        )}
        <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
          {body}
        </Typography>
      </Box>
    </Card>
  );
}
